import axios from 'axios';
import type {
  IGetManagedAccessKdpDetailsParams,
  IGetManagedAccessKdpDetailsResponse,
} from '@/app-package';

const getManagedAccessKdpDetails = async ({
  id,
}: IGetManagedAccessKdpDetailsParams): Promise<IGetManagedAccessKdpDetailsResponse> => {
  const { data } = await axios.get<IGetManagedAccessKdpDetailsResponse>(
    `/supra/managed_access_kdp/details/${id}`,
  );
  return data;
};

export default getManagedAccessKdpDetails;
